
<div class="container">
          
  <div class="logo"><img src="design/images/ey-logo.png" class="logo-top" /></div>
    
  <div class="flex-containers">
    <div class="text-area">
      <div class=" intros text ">
        <h1>Transitions Management Tool</h1>
       
        <p>Efficiently manage the process flow of activities handled by the
          <br>
          Pre-joining , Immigration & Offboarding teams for
          various resource types across countries in MENA region
        </p>
      </div>
    </div>
    <div class="arrow-up">
      <img src="design/images/Uparrow_Group.png" class="arrows slide-in-bl"/>
    </div>
  </div>
  <div class="icons fade-in-fwd delay-1">
    <div class="module-wrapper">
    <div class="modules">
      <img src="design/images/icon1.png" class="module-icons icon1">
      <label class="recuit-label labels-1">Recruitment</label>
      <div class="new-label" >
        <div class="label1">
      
                  
                   
          <a [eosHasAccess]="'RMT'" routerLink="/recruitment" *ngIf="isActiveModule('m-rmt')">
       
            Permanant Recruitment</a>
       
        </div>
        <div class="label2">
          <a routerLink="/subcontractor" [eosHasAccess]="'CW'" *ngIf="isActiveModule('m-cw')">
                       
                 
                      
       
            Subcontractor
          </a>
        </div>
      </div>
    </div>
    </div>
    
   <!-- <div class="modules">
    </div>
    
  <!-- <div class="modules">
    <img src="design/images/icon1.png" class="module-icons icon1">
    <label class="recuit-label labels-1">Recruitment</label>   
  
   </div> -->
    <div class="modules"  [eosHasAccess]="'PTC'">
      <img src="design/images/icon2.png" class="module-icons icon2">
      <a routerLink="/pre-boarding" *ngIf="isActiveModule('m-ptc')">
        <label class="labels">Pre-joining</label>
      </a>
    </div>
    <div class="modules">
      <img src="design/images/icon3.png" class="module-icons icon3">
    
                
                 
      <a [eosHasAccess]="'IMM'" routerLink="/immigration" *ngIf="isActiveModule('m-imm')">   
        <label class="labels">Immigration</label></a>  
    </div>
   
    <div class="modules" *ngIf="isActiveModule('m-ext')">
      <img src="design/images/icon4.png" class="module-icons  icon4">
      <a  [eosHasAccess]="'EXT'" routerLink="/exit">
        <label class="labels">Exit</label>
      </a>
    </div>
   
   
  </div>
  <div class="user" style="z-index:10;">
    <img src="design/images/user-1.png" routerLink="/user" />
<div
      class="dropdown"
      [autoClose]="isDropdownClose"
      #dropdown="ngbDropdown"
      ngbDropdown
      display="dynamic"
      placement="bottom-right">           
      <p class="dropdown-toggle" data-toggle="dropdown" ngbDropdownToggle>
        {{loggedInUserDisplayName}}
      </p>
      <div class="dropdown-menu" ngbDropdownMenu>
        <a class="dropdown-item" (click)="closeDropdown()" routerLink="/user" ngbDropdownItem>Profile</a>
        <a class="dropdown-item" *ngIf="isAdmin" (click)="closeDropdown()" routerLink="/admin" ngbDropdownItem>Admin</a> 
        <a class="dropdown-item" (click)="closeDropdown()" routerLink="/settings" ngbDropdownItem>Settings</a>
        <a  *ngIf="isAmendTask || isTemplateEditor || isConfigDropdownPJC"
          class="dropdown-item"
          (click)="selectOption('Prejoining', $event)"
          ngbDropdown
        >
          <p
            class="dropdown-arrow d-flex justify-content-between align-items-center"
          >
            Pre-joining
            <i
              [ngClass]="{
                'arrow-right': expandedItem !== 'Prejoining',
                'arrow-down': expandedItem === 'Prejoining'
              }"
            ></i>
          </p>
        </a>
        <div *ngIf="expandedItem === 'Prejoining'" style="padding-left: 20px">
          <a
            class="dropdown-item"
            *ngIf="isAmendTask"
            (click)="closeDropdown()"
            routerLink="/configure-activities"
            ngbDropdownItem
          >
            Configure activities
          </a>
          <a
            class="dropdown-item"
            *ngIf="isTemplateEditor"
            (click)="closeDropdown()"
            routerLink="/configure-template"
            ngbDropdownItem
          >
            Configure template
          </a>
          <a class="dropdown-item" *ngIf="isConfigDropdownPJC" (click)="closeDropdown()" routerLink="/configure-lookuptype/PJC" ngbDropdownItem>
            Configure
            dropdown
          </a>  
        </div>
        <a *ngIf="isImmActivityEditor || isImmTemplateEditor || isImmDocumentVisamapping || isConfigDropdownIMM"
          class="dropdown-item"
          (click)="selectOption('Immigration', $event)"
          ngbDropdown
        >
          <p
            class="dropdown-arrow d-flex justify-content-between align-items-center"
          >
            Immigration
            <i
              [ngClass]="{
                'arrow-right': expandedItem !== 'Immigration',
                'arrow-down': expandedItem === 'Immigration'
              }"
            ></i>
          </p>
        </a>
        <div *ngIf="expandedItem === 'Immigration'" style="padding-left: 20px">
          <a
            class="dropdown-item"
            *ngIf="isImmActivityEditor"
            (click)="closeDropdown()"
            routerLink="/configure-immactivities"
            ngbDropdownItem
          >
            Configure activities
          </a>
          <a
            class="dropdown-item"
            *ngIf="isImmTemplateEditor"
            (click)="closeDropdown()"
            routerLink="/configure-Immtemplate"
            ngbDropdownItem
          >
            Configure template
          </a>
          <a
            class="dropdown-item"
            *ngIf="isImmDocumentVisamapping"
            (click)="closeDropdown()"
            routerLink="/configure-immdocumentvisamapping"
            ngbDropdownItem
          >
            Configure document
          </a>
          <a class="dropdown-item" *ngIf="isConfigDropdownIMM" (click)="closeDropdown()" routerLink="/configure-lookuptype/IMM" ngbDropdownItem>
            Configure
            dropdown
          </a>  
        </div>

        <a *ngIf="isGovernanceDocumentTypeEditor || isGovernanceActivityEditor"
          class="dropdown-item"
          (click)="selectOption('Governance', $event)"
          ngbDropdown>
          <p class="dropdown-arrow d-flex justify-content-between align-items-center">
            Governance
            <i
              [ngClass]="{
                'arrow-right': expandedItem !== 'Governance',
                'arrow-down': expandedItem === 'Governance'
              }"
            ></i>
          </p>
        </a>

        <div *ngIf="expandedItem === 'Governance'" style="padding-left: 20px">

          <a
            class="dropdown-item"
            *ngIf="isGovernanceDocumentTypeEditor"
            (click)="closeDropdown()"
            routerLink="/configure-governance-newdocument-types"
            ngbDropdownItem>
            Create document type
          </a>
          
          <a
            class="dropdown-item"
             *ngIf="isGovernanceDocumentTypeEditor"
            (click)="closeDropdown()"
            routerLink="/configure-governance-document-types"
            ngbDropdownItem>
            Configure document mapping
          </a>

          <a
            class="dropdown-item"
            *ngIf="isGovernanceDocumentTypeEditor"
            (click)="closeDropdown()"
            routerLink="/configure-governance-doc-mapping"
            ngbDropdownItem>
            Configure document CM9 mapping
          </a>

          <a
            class="dropdown-item"
             *ngIf="isGovernanceActivityEditor"
            (click)="closeDropdown()"
            routerLink="/configure-governance-activities"
            ngbDropdownItem>
            Configure activities
          </a>
          <a
            class="dropdown-item"
             
            (click)="closeDropdown()"
            routerLink="/configure-Govtemplate"
            ngbDropdownItem>
            Configure template
          </a>
        </div>

        <a  *ngIf="isExitActivityEditor || isExitTemplateEditor || isConfigDropdownEXT"
          class="dropdown-item"
          (click)="selectOption('Exit', $event)"
          ngbDropdown
        >
          <p
            class="dropdown-arrow d-flex justify-content-between align-items-center"
          >
            Exit
            <i
              [ngClass]="{
                'arrow-right': expandedItem !== 'Exit',
                'arrow-down': expandedItem === 'Exit'
              }"
            ></i>
          </p>
        </a>
        <div *ngIf="expandedItem === 'Exit'" style="padding-left: 20px">
          <a
            class="dropdown-item"
            *ngIf="isExitActivityEditor"
            (click)="closeDropdown()"
            routerLink="/configure-exitactivities"
            ngbDropdownItem
          >
            Configure activities
          </a>
          <a
            class="dropdown-item"
            *ngIf="isExitTemplateEditor"
            (click)="closeDropdown()"
            routerLink="/configure-exit-template-editor"
            ngbDropdownItem
          >
            Configure template
          </a>
          <a class="dropdown-item" *ngIf="isConfigDropdownEXT" (click)="closeDropdown()" routerLink="/configure-lookuptype/EXT" ngbDropdownItem>
            Configure
            dropdown
          </a> 
        </div>
        <a class="dropdown-item" *ngIf="isAdmin" (click)="closeDropdown()" routerLink="/configure-lookuptype/TMT" ngbDropdownItem>
          Configure common dropdowns
        </a>   
        <a class="dropdown-item" [routerLink]="" (click)="logout()" ngbDropdownItem>Logout</a>                                
      </div>    
    </div> 
  </div>   
</div>
